import AppHeader from '../AppHeader'
export default {
  name: 'video-categories',
  components: {
    AppHeader
  },
  created () {
    window.scrollTo(0, 0)
  },
  data () {
    return {
      ruleList: {
        'アテンダントマニュアル': 'yes_we_can'
      },
      ruleList2: {
        '礼節と礼儀': 'video_courtesy',
        '接客と接遇': 'video_customer_service',
        'ルールと設備': 'video_raw_facility',
        '接客評価のポイント': 'video_service_question_point'
      }
    }
  },
  computed: {
  },
  methods: {
    goTop: function () {
      this.$router.push({path: '/'})
    },
    goToRule: function (path) {
      this.$router.push({path: path})
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/scripts/video-categories.js